/*    
<summary>
   This file is used to provide initial values or state to the Fota Module observables.
   Developer: Aashish Singh, Created Date: 28-August-2024
</summary>
*/

import { IFotaHostConfigListVM, IFotaHostScheduleListVM, IFotaMzlConfigListVM, IFotaTntConfigListVM } from "../../models/response/IFotaNewResponse"


//Default values for both master's fota mzl...Jet & modem .[Deepak Paliwal-22 -Aug-2025]
export const getInitialFotaMzlConfigListState: IFotaMzlConfigListVM= {
    PagingDetails: {
        TotalRecords: 1,
        TotalPages: 1,
        CurrentPage: 1,
        PageSize: 10,
    },
    Configs: []
}


export const getInitialFotaHostConfigListState: IFotaHostConfigListVM= {
    PagingDetails: {
        TotalRecords: 1,
        TotalPages: 1,
        CurrentPage: 1,
        PageSize: 10,
    },
    Configs: []
}

export const getInitialFotaTntConfigListState: IFotaTntConfigListVM= {
    PagingDetails: {
        TotalRecords: 1,
        TotalPages: 1,
        CurrentPage: 1,
        PageSize: 10,
    },
    Configs: []
}

export const getInitialFotaHostScheduleListState: IFotaHostScheduleListVM= {
    PagingDetails: {
        TotalRecords: 1,
        TotalPages: 1,
        CurrentPage: 1,
        PageSize: 10,
    },
    Schedules: []
}